import * as React from 'react';

import PropTypes from 'prop-types';
import { alpha } from '@mui/material/styles';
import Box from '@mui/material/Box';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TablePagination from '@mui/material/TablePagination';
import TableRow from '@mui/material/TableRow';
import TableSortLabel from '@mui/material/TableSortLabel';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import Paper from '@mui/material/Paper';
import Checkbox from '@mui/material/Checkbox';
import IconButton from '@mui/material/IconButton';
import Tooltip from '@mui/material/Tooltip';
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch from '@mui/material/Switch';
import DeleteIcon from '@mui/icons-material/Delete';
import FilterListIcon from '@mui/icons-material/FilterList';
import { visuallyHidden } from '@mui/utils';
import { useAxiosGet } from '../Hooks/HttpRequests'
import { makeStyles } from '@material-ui/core/styles';
import { smdTeams } from '../data/teamMap';

const useStyles = makeStyles({
  customTable: {
    "& .MuiTableCell-sizeSmall": {
      padding: "6px 0px 6px 16px", // <-- arbitrary value
      width: "max-content"
    }
  },
});

function descendingComparator(a, b, orderBy) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

function getComparator(order, orderBy) {
  return order === 'desc'
    ? (a, b) => descendingComparator(a, b, orderBy)
    : (a, b) => -descendingComparator(a, b, orderBy);
}

// This method is created for cross-browser compatibility, if you don't
// need to support IE11, you can use Array.prototype.sort() directly
// function stableSort(array, comparator) {
//   const stabilizedThis = array.map((el, index) => [el, index]);
//   stabilizedThis.sort((a, b) => {
//     const order = comparator(a[0], b[0]);
//     if (order !== 0) {
//       return order;
//     }
//     return a[1] - b[1];
//   });
//   return stabilizedThis.map((el) => el[0]);
// }
function stableSort(array, comparator) {
  if (Array.isArray(array)) {
    return array.sort((a, b) => {
      const order = comparator(a, b);
      if (order !== 0) {
        return order;
      }
      return 0;
    });
  } else {
    // Handle the case where `array` is not an array
    console.error('stableSort: Input is not an array');
    console.log(array);
    return array;
  }
}


function EnhancedTableHead(props) {
  const { onSelectAllClick, order, orderBy, numSelected, rowCount, onRequestSort, headCells } =
    props;
  const createSortHandler = (property) => (event) => {
    onRequestSort(event, property);
  };

  return (
    <TableHead>
      <TableRow>
        {/* <TableCell padding="checkbox"> */}
          {/* <Checkbox
            color="primary"
            indeterminate={numSelected > 0 && numSelected < rowCount}
            checked={rowCount > 0 && numSelected === rowCount}
            onChange={onSelectAllClick}
            inputProps={{
              'aria-label': 'select all desserts',
            }}
          /> */}
        {/* </TableCell> */}
        {headCells.map((headCell) => (
          <TableCell
            key={headCell.id}
            align={headCell.numeric ? 'left' : 'left'}
            // padding={headCell.disablePadding ? 'none' : 'normal'}
            sortDirection={orderBy === headCell.id ? order : false}
            width= "max-content"
            // padding= "none"
            sx={{
              fontSize: "small",
              padding: "6px 0px 6px 6px",
              ...(headCell.minWidth ? { minWidth: headCell.minWidth } : {}),
              ...(headCell.maxWidth ? { maxWidth: headCell.maxWidth } : {}),
              ...(headCell.width ? { width: headCell.width } : {}),
              ...(headCell.sx || {}),
            }}
          >
            <TableSortLabel
              active={orderBy === headCell.id}
              // hideSortIcon='false'
              direction={orderBy === headCell.id ? order : 'asc'}
              onClick={createSortHandler(headCell.id)}
            >
              {headCell.label}
              {orderBy === headCell.id ? (
                <Box component="span" sx={visuallyHidden}>
                  {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                </Box>
              ) : null}
            </TableSortLabel>
          </TableCell>
        ))}
      </TableRow>
    </TableHead>
  );
}

EnhancedTableHead.propTypes = {
  numSelected: PropTypes.number.isRequired,
  onRequestSort: PropTypes.func.isRequired,
  // onSelectAllClick: PropTypes.func.isRequired,
  order: PropTypes.oneOf(['asc', 'desc']).isRequired,
  orderBy: PropTypes.string.isRequired,
  rowCount: PropTypes.number.isRequired,
  headCells: PropTypes.array.isRequired
};

function EnhancedTableToolbar(props) {
  const { numSelected } = props;

  return (
    <Toolbar
      sx={{
        pl: { sm: 2 },
        pr: { xs: 1, sm: 1 },
        // ...(numSelected > 0 && {
        //   bgcolor: (theme) =>
        //     alpha(theme.palette.primary.main, theme.palette.action.activatedOpacity),
        // }),
      }}
    >
      <Typography
        sx={{ flex: '1 1 100%' }}
        variant="h6"
        id="tableTitle"
        component="div"
        className="uppercase"
      >
        {props.title}
      </Typography>
    </Toolbar>
  );
}

EnhancedTableToolbar.propTypes = {
  numSelected: PropTypes.number.isRequired,
};

export default function MuiTable(props) {
  const [order, setOrder] = React.useState(props.defaultOrder || 'asc');
  const [orderBy, setOrderBy] = React.useState(
    props.defaultOrderBy || ((props.headCells && props.headCells.length && props.headCells[0].id) || 'rank')
  );
  const [selected, setSelected] = React.useState([]);
  const [page, setPage] = React.useState(0);
  const [dense, setDense] = React.useState(true);
  // Default to a sensible page size if none provided
  const [rowsPerPage, setRowsPerPage] = React.useState(props.page || 10);

  const url = props.url

  const classes = useStyles();

  let product = useAxiosGet(url)

  // Optional supporting data: player map for translating IDs to names
  const playersResponse = useAxiosGet('https://supermegadynasty.com/smd_all_players.json');

  // Shared player map + resolver for name lookup across blocks
  let playerMap = null;
  const resolveNameFromAny = (val) => {
    if (val === undefined || val === null) return null;
    if (typeof val === 'object') {
      const pid = val.player_id || val.id || val.player || val.pid || val.playerId || val.playerID || val.sleeper_id;
      return resolveNameFromAny(pid);
    }
    const s = String(val);
    if (/^\d+$/.test(s)) {
      if (playerMap && playerMap[s]) {
        const p = playerMap[s];
        if (p.full_name) return p.full_name;
        if (p.first_name || p.last_name) return `${p.first_name || ''} ${p.last_name || ''}`.trim();
        return p.name || null;
      }
      return null;
    }
    return s;
  };

  // Reset pagination when the data source (URL) changes
  React.useEffect(() => {
    setPage(0);
  }, [url]);

  if(!props.rows && product.error){
    return (
      <div>
        <div className="bg-blue-300 mb-2 p-3">
              If you see this error, there was an issue loading the data - It will never be fixed, you might as well give up.
          </div>
          <div className="bg-red-300 p-3">
              There was an error please refresh or try again later, or don't IDGAF.
          </div>
      </div>
    )
  }

  // Allow caller to provide rows directly (skips fetching and parsing)
  let rows = props.rows != null ? props.rows : product.data
  // Some endpoints may respond with JSON as text/html or double-encoded strings
  const decodeEntities = (s) => (
    s
      .replace(/&quot;|&#34;/g, '"')
      .replace(/&#39;|&apos;/g, "'")
      .replace(/&lt;/g, '<')
      .replace(/&gt;/g, '>')
      .replace(/&amp;/g, '&')
  );
  const stripHTML = (s) => s
      .replace(/<script[\s\S]*?<\/script>/gi, '')
      .replace(/<style[\s\S]*?<\/style>/gi, '')
      .replace(/<[^>]*>/g, '');
  const deepParse = (val) => {
    let out = val;
    for (let i = 0; i < 3 && typeof out === 'string'; i++) {
      try { out = JSON.parse(out); } catch (_) { break; }
    }
    if (typeof out === 'string') {
      if (out.includes('<') && out.includes('>')) {
        out = decodeEntities(stripHTML(out));
      }
      const s = out.indexOf('[');
      const e = out.lastIndexOf(']');
      if (s !== -1 && e > s) {
        const slice = out.slice(s, e + 1).trim();
        try { out = JSON.parse(slice); } catch (_) {}
      }
    }
    return out;
  };
  if (typeof rows === 'string') rows = deepParse(rows);
  console.log(rows)

  if((!props.rows && product.data) || (props.rows && rows)) {
    // Build a player ID -> player object map if available
    if (playersResponse && playersResponse.data) {
      const pdata = playersResponse.data;
      if (pdata && typeof pdata === 'object' && !Array.isArray(pdata)) {
        playerMap = pdata;
      } else if (Array.isArray(pdata)) {
        playerMap = pdata.reduce((acc, p) => {
          const id = (p && (p.player_id || p.id || p.playerId || p.playerID)) ?? null;
          if (id !== null) acc[String(id)] = p;
          return acc;
        }, {});
      }
    }
    // Special handling for Starting % tables where the API may send an array
    // or an object keyed by numeric indices, or even a JSON string
    if (props.table === 'start') {
      // Normalize rows for Starting % table using the already-parsed `rows` when possible
      let d = rows;
      if (typeof d === 'string') {
        // Trim BOM/whitespace and parse
        const s = d.replace(/^\uFEFF/, '').trim();
        try { d = JSON.parse(s); } catch (_) {
          // Try extracting the first JSON array substring
          const b = s.indexOf('[');
          const e = s.lastIndexOf(']');
          if (b !== -1 && e > b) {
            try { d = JSON.parse(s.slice(b, e + 1)); } catch (_) {}
          }
        }
      }
      if (Array.isArray(d)) {
        rows = d;
      } else if (d && typeof d === 'object') {
        const keys = Object.keys(d);
        // If object keys are numeric-like (e.g., {"0": {...}, "1": {...}}), build an ordered array
        const numericLike = keys.length && keys.every((k) => /^\d+$/.test(k));
        if (numericLike) {
          rows = keys
            .sort((a, b) => Number(a) - Number(b))
            .map((k) => d[k])
            .filter((v) => v && typeof v === 'object');
        } else {
          const vals = Object.values(d);
          if (vals.length && vals.every((v) => v && typeof v === 'object')) {
            rows = vals;
          }
        }
      }
    }
    if (props.table === 'rosters' && !props.rows) {
      rows = product.data.player_map
    }

    // Normalize and enrich H2H rows to expose per-opponent columns
    if (props.table === 'h2h') {
      // Ensure rows is an array
      let d = rows;
      if (typeof d === 'string') {
        try { d = JSON.parse(d); } catch (_) {}
      }
      if (d && !Array.isArray(d) && typeof d === 'object') {
        const values = Object.values(d);
        // If looks like a map of teams -> row objects, take values
        if (values.length && values.every((v) => v && typeof v === 'object')) {
          d = values;
        }
      }
      if (Array.isArray(d)) rows = d;

      // Helper: render record objects/values into W-L(-T)
      const formatRecord = (val) => {
        if (val === undefined || val === null) return '';
        if (typeof val === 'string' || typeof val === 'number') return String(val);
        if (typeof val === 'object') {
          const w = val.wins ?? val.w ?? val.W ?? val.win ?? val.total_wins;
          const l = val.losses ?? val.l ?? val.L ?? val.loss ?? val.total_losses;
          const t = val.ties ?? val.t ?? val.T ?? val.tie ?? val.total_ties;
          if (w !== undefined || l !== undefined) {
            return `${w ?? 0}-${l ?? 0}${t !== undefined ? `-${t}` : ''}`;
          }
          try { return JSON.stringify(val); } catch (_) { return String(val); }
        }
        return String(val);
      };

      const usernameById = (id) => {
        const n = Number(id);
        if (!isNaN(n)) {
          const found = smdTeams.find((t) => t.roster_id === n || String(t.owner_id) === String(id));
          if (found) return found.username;
        }
        // Try owner_id exact match or username pass-through
        const found = smdTeams.find((t) => String(t.owner_id) === String(id) || t.username === id);
        return found ? found.username : String(id);
      };

      const opponentMaps = ['record_vs', 'records_vs', 'vs', 'opponents', 'vs_record', 'h2h_vs', 'head_to_head', 'h2h'];
      rows.forEach((rowObj) => {
        if (!rowObj || typeof rowObj !== 'object') return;
        // Find any embedded opponent map
        let mapObj = null;
        for (const k of opponentMaps) {
          if (rowObj[k] && typeof rowObj[k] === 'object') { mapObj = rowObj[k]; break; }
        }
        if (!mapObj) return;
        Object.entries(mapObj).forEach(([k, v]) => {
          const uname = usernameById(k);
          const fld = `record_vs_${uname}`;
          if (rowObj[fld] === undefined || rowObj[fld] === null || rowObj[fld] === '') {
            rowObj[fld] = formatRecord(v);
          }
        });
      });

      // Also synthesize record fields from wins_vs_*/losses_vs_* pairs (2024 format)
      rows.forEach((rowObj) => {
        if (!rowObj || typeof rowObj !== 'object') return;
        Object.keys(rowObj).forEach((k) => {
          if (k.startsWith('wins_vs_')) {
            const suffix = k.slice('wins_vs_'.length);
            const w = rowObj[k];
            const l = rowObj[`losses_vs_${suffix}`];
            if (w !== undefined && l !== undefined) {
              const fld = `record_vs_${suffix}`;
              if (rowObj[fld] === undefined || rowObj[fld] === null || rowObj[fld] === '') {
                rowObj[fld] = `${w}-${l}`;
              }
            }
          }
        });
      });
    }

    if (props.table === 'most_traded') {
      // Ensure last_trade is a Date object so sorting uses chronological order
      rows.forEach((rowObj) => {
        if (rowObj && rowObj.last_trade !== undefined && rowObj.last_trade !== null) {
          let v = rowObj.last_trade;
          // handle epoch seconds/millis and ISO strings
          if (typeof v === 'string') {
            const asNum = Number(v);
            if (!isNaN(asNum)) v = asNum;
          }
          if (typeof v === 'number') {
            if (v < 1e12) v = v * 1000; // seconds -> ms
            rowObj.last_trade = new Date(v);
          } else {
            const d = new Date(v);
            if (!isNaN(d)) rowObj.last_trade = d;
          }
        }
      });
    }

    if (props.table === 'traded_picks') {
      let map = smdTeams
      // iterate within the compiledData objects
      rows.forEach(rowObj => {
        // filter function return the objects that fulfil the requirements (if return is true, then the object is added, else not)
        const objOwnerId = map.filter(mapObj => {
            // return the objects with the same location only
            return mapObj.roster_id === rowObj.owner_id
        });

        const objPrevOwnerId = map.filter(mapObj => {
          // return the objects with the same location only
          return mapObj.roster_id === rowObj.previous_owner_id
        });

        const objRosterId = map.filter(mapObj => {
          // return the objects with the same location only
          return mapObj.roster_id === rowObj.roster_id
        });

        // iterate within the objects returned
        objOwnerId.forEach(obj => {
            // within the rowObject, get the year parameter and fill the price that matched the same year
            rowObj.owner_id = obj.username
        });

        // iterate within the objects returned
        objPrevOwnerId.forEach(obj => {
          // within the rowObject, get the year parameter and fill the price that matched the same year
          rowObj.previous_owner_id = obj.username
        });

        // iterate within the objects returned
        objRosterId.forEach(obj => {
          // within the rowObject, get the year parameter and fill the price that matched the same year
          rowObj.roster_id = obj.username
        });
      });
    }

    if (props.table === 'trades') {
      console.log("Table type...trades")
      let map = smdTeams
      // iterate within the compiledData objects
      rows.forEach(rowObj => {
        // filter function return the objects that fulfil the requirements (if return is true, then the object is added, else not)
        const objOwnerId = map.filter(mapObj => {
            // return the objects with the same location only
            return mapObj.roster_id === rowObj.roster_ids[0]
        });

        const objPrevOwnerId = map.filter(mapObj => {
          // return the objects with the same location only
          return mapObj.roster_id === rowObj.roster_ids[1]
        });

        // const objRosterId = map.filter(mapObj => {
        //   // return the objects with the same location only
        //   return mapObj.roster_id === rowObj.roster_ids[1]
        // });

        // iterate within the objects returned
        objOwnerId.forEach(obj => {
            // within the rowObject, get the year parameter and fill the price that matched the same year
            rowObj.roster1 = obj.username
        });

        // iterate within the objects returned
        objPrevOwnerId.forEach(obj => {
          // within the rowObject, get the year parameter and fill the price that matched the same year
          rowObj.roster2 = obj.username
        });


        console.log(rowObj)
      });
    }

    if (props.table === 'last_trades') {
      // Normalize rows and format fields for Last Trades table
      let d = rows;
      if (typeof d === 'string') {
        try { d = JSON.parse(d); } catch (_) {}
      }
      if (d && !Array.isArray(d) && typeof d === 'object') {
        const keys = Object.keys(d);
        const numericLike = keys.length && keys.every((k) => /^\d+$/.test(k));
        if (numericLike) {
          d = keys.sort((a,b) => Number(a)-Number(b)).map((k) => d[k]);
        } else {
          d = Object.values(d);
        }
      }
      if (Array.isArray(d)) {
        rows = d;
      }

      // Map roster/team identifiers and format last_trade as human date
      const map = smdTeams;
      const partnerName = (id) => {
        const found = map.find((m) => m.roster_id === id || m.owner_id === id || m.username === id);
        return found ? found.username : String(id);
      };

      const formatDateYMD = (d) => {
        const y = d.getFullYear();
        const m = String(d.getMonth() + 1).padStart(2, '0');
        const day = String(d.getDate()).padStart(2, '0');
        return `${y}/${m}/${day}`;
      };

      const idToPlayerName = (id) => {
        if (playerMap) {
          const key = String(id);
          const p = playerMap[key];
          if (p) {
            if (p.full_name) return p.full_name;
            if (p.first_name || p.last_name) return `${p.first_name || ''} ${p.last_name || ''}`.trim();
            return p.name || String(id);
          }
        }
        return String(id);
      };

      
      // Convert players adds/drops to an array of names (Last Trades: we render arrays on separate lines)
      const summarizePlayers = (val) => {
        if (!val) return [];
        const names = [];
        if (Array.isArray(val)) {
          val.forEach((x) => names.push(idToPlayerName(x)));
          return names;
        }
        if (typeof val === 'object') {
          const entries = Object.entries(val);
          // Case 1: object of player_id -> roster_id
          const looksLikePlayerIdKeys = entries.length > 0 && entries.every(([k, v]) => (
            (playerMap && playerMap[String(k)]) || /^\d+$/.test(String(k))
          ));
          if (looksLikePlayerIdKeys) {
            entries.forEach(([k, _v]) => names.push(idToPlayerName(k)));
            return names;
          }
          // Case 2: object of roster_id -> [player_ids]
          entries.forEach(([k, v]) => {
            if (Array.isArray(v)) {
              v.forEach((pid) => names.push(idToPlayerName(pid)));
            } else if (v && typeof v === 'object') {
              if (v.player_id || v.id) names.push(idToPlayerName(v.player_id || v.id));
            } else if (v !== undefined && v !== null) {
              // might be a single player id
              names.push(idToPlayerName(v));
            }
          });
          return names;
        }
        return [idToPlayerName(val)];
      };

      // Convert draft picks structures to readable text
      const summarizePicks = (val) => {
        if (!val) return [];
        if (Array.isArray(val)) {
          // draft picks array or strings
          return val.map((item) => {
            if (item && typeof item === 'object') {
              const { season, round, roster_id, owner_id, og_owner_id } = item;
              if (season && round) {
                const owner = partnerName(roster_id || owner_id || og_owner_id || '');
                return `${season} R${round}${owner ? ` (${owner})` : ''}`;
              }
              try { return JSON.stringify(item); } catch (_) { return String(item); }
            }
            return String(item);
          });
        }
        if (typeof val === 'object') {
          // Object of arrays or values; flatten values
          const parts = [];
          Object.entries(val).forEach(([k, v]) => {
            if (Array.isArray(v)) {
              parts.push(...v.map((x) => `${partnerName(k)}: ${x}`));
            } else if (v && typeof v === 'object') {
              try { parts.push(`${partnerName(k)}: ${JSON.stringify(v)}`); } catch (_) { parts.push(`${partnerName(k)}: ${String(v)}`); }
            } else if (v !== undefined && v !== null) {
              parts.push(`${partnerName(k)}: ${String(v)}`);
            }
          });
          return parts;
        }
        return [String(val)];
      };

      rows.forEach((rowObj) => {
        // Set username if absent using roster_id/owner_id
        if (!rowObj.username) {
          const id = rowObj.roster_id ?? rowObj.owner_id;
          if (id !== undefined) {
            const found = map.find((m) => m.roster_id === id || m.owner_id === id);
            if (found) rowObj.username = found.username;
          }
        }
        const setDateFrom = (src) => {
          if (src === undefined || src === null) return undefined;
          let c = src;
          if (typeof c === 'string') {
            // numeric string or ISO string
            const n = Number(c);
            if (!isNaN(n)) c = n;
          }
          if (typeof c === 'number') {
            if (c < 1e12) c = c * 1000; // seconds to ms
            const d = new Date(c);
            if (!isNaN(d)) {
              rowObj.last_trade_date = formatDateYMD(d);
              return d.getTime();
            }
          } else if (typeof c === 'string') {
            const parsed = new Date(c);
            if (!isNaN(parsed)) {
              rowObj.last_trade_date = formatDateYMD(parsed);
              return parsed.getTime();
            }
          } else if (c instanceof Date) {
            rowObj.last_trade_date = formatDateYMD(c);
            return c.getTime();
          }
          return undefined;
        };

        if (rowObj.last_trade !== undefined && rowObj.last_trade !== null) {
          let dt = rowObj.last_trade;
          let tsMs;
          if (typeof dt === 'number') {
            // seconds vs millis
            if (dt < 1e12) dt = dt * 1000;
            const d = new Date(dt);
            rowObj.last_trade_date = formatDateYMD(d);
            tsMs = d.getTime();
          } else if (typeof dt === 'object') {
            // Prefer explicit localized string if provided
            if (dt.create && dt.create.local) {
              const parsed = new Date(dt.create.local);
              if (!isNaN(parsed)) {
                rowObj.last_trade_date = formatDateYMD(parsed);
                tsMs = parsed.getTime();
              } else {
                rowObj.last_trade_date = String(dt.create.local);
              }
            } else if (dt.created && dt.created.local) {
              const parsed = new Date(dt.created.local);
              if (!isNaN(parsed)) {
                rowObj.last_trade_date = formatDateYMD(parsed);
                tsMs = parsed.getTime();
              } else {
                rowObj.last_trade_date = String(dt.created.local);
              }
            }
            // Fallbacks to timestamps/ISO strings
            if (!tsMs) tsMs = setDateFrom(dt.created);
            if (!tsMs) tsMs = setDateFrom(dt.timestamp);
            if (!tsMs) tsMs = setDateFrom(dt.date);
            if (!tsMs && dt.metadata && (dt.metadata.created || dt.metadata.timestamp)) {
              tsMs = setDateFrom(dt.metadata.created || dt.metadata.timestamp);
            }
            // Populate detailed columns
            rowObj.last_trade_type = dt.type || rowObj.last_trade_type;
            // partner names
            if (Array.isArray(dt.partner_team_names) && dt.partner_team_names.length) {
              rowObj.last_trade_partners = dt.partner_team_names.slice();
            } else if (Array.isArray(dt.partners) && dt.partners.length) {
              rowObj.last_trade_partners = dt.partners.map(partnerName);
            }
            // assets
            rowObj.last_trade_adds  = summarizePlayers(dt.adds);
            rowObj.last_trade_drops = summarizePlayers(dt.drops);
            rowObj.last_trade_picks = summarizePicks(dt.draft_picks);

            // Align draft picks into Adds/Drops for this team based on ownership
            // Rule: if pick.owner_id == row.roster_id then it's an Add for this row; otherwise a Drop
            if (Array.isArray(dt.draft_picks)) {
              const rid = Number(rowObj.roster_id ?? rowObj.owner_id);
              const addPickStrs = [];
              const dropPickStrs = [];
              dt.draft_picks.forEach((pick) => {
                if (!pick || pick.owner_id === undefined || pick.owner_id === null) return;
                const strs = summarizePicks([pick]); // array with one formatted string
                if (Number(pick.owner_id) === rid) addPickStrs.push(...strs);
                else dropPickStrs.push(...strs);
              });
              if (addPickStrs.length) {
                rowObj.last_trade_adds = [...(Array.isArray(rowObj.last_trade_adds) ? rowObj.last_trade_adds : [rowObj.last_trade_adds].filter(Boolean)), ...addPickStrs];
              }
              if (dropPickStrs.length) {
                rowObj.last_trade_drops = [...(Array.isArray(rowObj.last_trade_drops) ? rowObj.last_trade_drops : [rowObj.last_trade_drops].filter(Boolean)), ...dropPickStrs];
              }
            }
            // waiver budget (sum if object)
            if (dt.waiver_budget && typeof dt.waiver_budget === 'object') {
              let sum = 0;
              Object.values(dt.waiver_budget).forEach((v) => { const n = Number(v); if (!isNaN(n)) sum += n; });
              rowObj.last_trade_waiver = sum;
            } else if (typeof dt.waiver_budget === 'number') {
              rowObj.last_trade_waiver = dt.waiver_budget;
            }
            // id
            if (dt.transaction_id) rowObj.last_trade_id = dt.transaction_id;
          } else {
            const parsed = new Date(dt);
            if (!isNaN(parsed)) {
              rowObj.last_trade_date = formatDateYMD(parsed);
              tsMs = parsed.getTime();
            }
          }
          if (tsMs) {
            const msPerDay = 1000 * 60 * 60 * 24;
            rowObj.last_trade_days = Math.max(0, Math.floor((Date.now() - tsMs) / msPerDay));
          }
        }
      });
    }

    if (props.table === 'enriched_trades') {
      // Normalize rows for Enriched Trades table
      let d = rows;
      if (typeof d === 'string') {
        try { d = JSON.parse(d); } catch (_) {}
      }
      if (d && !Array.isArray(d) && typeof d === 'object') {
        const keys = Object.keys(d);
        const numericLike = keys.length && keys.every((k) => /^\d+$/.test(k));
        if (numericLike) {
          d = keys.sort((a,b) => Number(a)-Number(b)).map((k) => d[k]);
        } else {
          d = Object.values(d);
        }
      }
      if (Array.isArray(d)) {
        rows = d;
      }

      const map = smdTeams;
      const partnerName = (id) => {
        const found = map.find((m) => m.roster_id === id || m.owner_id === id || m.username === id);
        return found ? found.username : String(id);
      };

      const formatDateYMD = (d) => {
        const y = d.getFullYear();
        const m = String(d.getMonth() + 1).padStart(2, '0');
        const day = String(d.getDate()).padStart(2, '0');
        return `${y}/${m}/${day}`;
      };

      const idToPlayerName = (id) => {
        if (playerMap) {
          const key = String(id);
          const p = playerMap[key];
          if (p) {
            if (p.full_name) return p.full_name;
            if (p.first_name || p.last_name) return `${p.first_name || ''} ${p.last_name || ''}`.trim();
            return p.name || String(id);
          }
        }
        return String(id);
      };

      const summarizePlayers = (val) => {
        if (!val) return '';
        const names = [];
        if (Array.isArray(val)) {
          val.forEach((x) => names.push(idToPlayerName(x)));
          return names.join(', ');
        }
        if (typeof val === 'object') {
          const entries = Object.entries(val);
          const looksLikePlayerIdKeys = entries.length > 0 && entries.every(([k, v]) => (
            (playerMap && playerMap[String(k)]) || /^\d+$/.test(String(k))
          ));
          if (looksLikePlayerIdKeys) {
            entries.forEach(([k, _v]) => names.push(idToPlayerName(k)));
            return names.join(', ');
          }
          entries.forEach(([k, v]) => {
            if (Array.isArray(v)) {
              v.forEach((pid) => names.push(idToPlayerName(pid)));
            } else if (v && typeof v === 'object') {
              if (v.player_id || v.id) names.push(idToPlayerName(v.player_id || v.id));
            } else if (v !== undefined && v !== null) {
              names.push(idToPlayerName(v));
            }
          });
          return names.join(', ');
        }
        return idToPlayerName(val);
      };

      const summarizePicks = (val) => {
        if (!val) return '';
        if (Array.isArray(val)) {
          return val.map((item) => {
            if (item && typeof item === 'object') {
              const { season, round, roster_id, owner_id, og_owner_id } = item;
              if (season && round) {
                const owner = partnerName(roster_id || owner_id || og_owner_id || '');
                return `${season} R${round}${owner ? ` (${owner})` : ''}`;
              }
              try { return JSON.stringify(item); } catch (_) { return String(item); }
            }
            return String(item);
          }).join(', ');
        }
        if (typeof val === 'object') {
          const parts = [];
          Object.entries(val).forEach(([k, v]) => {
            if (Array.isArray(v)) {
              parts.push(`${partnerName(k)}: ${v.join(', ')}`);
            } else if (v && typeof v === 'object') {
              try { parts.push(`${partnerName(k)}: ${JSON.stringify(v)}`); } catch (_) { parts.push(`${partnerName(k)}: ${String(v)}`); }
            } else if (v !== undefined && v !== null) {
              parts.push(`${partnerName(k)}: ${String(v)}`);
            }
          });
          return parts.join(' | ');
        }
        return String(val);
      };

      const setTradeDate = (rowObj, dt) => {
        let tsMs;
        const setFrom = (src) => {
          if (src === undefined || src === null) return undefined;
          let c = src;
          if (typeof c === 'string') {
            const n = Number(c);
            if (!isNaN(n)) c = n;
          }
          if (typeof c === 'number') {
            if (c < 1e12) c = c * 1000;
            const d = new Date(c);
            if (!isNaN(d)) { rowObj.trade_date = formatDateYMD(d); return d.getTime(); }
          } else if (typeof c === 'string') {
            const parsed = new Date(c);
            if (!isNaN(parsed)) { rowObj.trade_date = formatDateYMD(parsed); return parsed.getTime(); }
          } else if (c instanceof Date) {
            rowObj.trade_date = formatDateYMD(c); return c.getTime();
          }
          return undefined;
        };

        if (typeof dt === 'number') {
          if (dt < 1e12) dt = dt * 1000;
          const d = new Date(dt); rowObj.trade_date = formatDateYMD(d); tsMs = d.getTime();
        } else if (typeof dt === 'object') {
          if (dt.create && dt.create.local) {
            const parsed = new Date(dt.create.local);
            if (!isNaN(parsed)) { rowObj.trade_date = formatDateYMD(parsed); tsMs = parsed.getTime(); }
            else rowObj.trade_date = String(dt.create.local);
          } else if (dt.created && dt.created.local) {
            const parsed = new Date(dt.created.local);
            if (!isNaN(parsed)) { rowObj.trade_date = formatDateYMD(parsed); tsMs = parsed.getTime(); }
            else rowObj.trade_date = String(dt.created.local);
          }
          if (!tsMs) tsMs = setFrom(dt.created);
          if (!tsMs) tsMs = setFrom(dt.timestamp);
          if (!tsMs) tsMs = setFrom(dt.date);
        } else {
          const parsed = new Date(dt);
          if (!isNaN(parsed)) { rowObj.trade_date = formatDateYMD(parsed); tsMs = parsed.getTime(); }
        }
        return tsMs;
      };

      rows.forEach((rowObj) => {
        // Compute date
        if (rowObj.last_trade !== undefined && rowObj.last_trade !== null) {
          setTradeDate(rowObj, rowObj.last_trade);
        } else if (rowObj.trade || rowObj.created) {
          setTradeDate(rowObj, rowObj.trade || rowObj.created);
        }

        // Partners (robust extraction)
        const base = rowObj.last_trade && typeof rowObj.last_trade === 'object' ? rowObj.last_trade : rowObj;
        let partners = [];
        const pushName = (x) => {
          if (x === undefined || x === null) return;
          // numeric roster/owner id -> team name
          if (typeof x === 'number' || /^\d+$/.test(String(x))) partners.push(partnerName(x));
          else partners.push(String(x));
        }
        const pushRosterId = (x) => {
          if (x === undefined || x === null) return;
          if (typeof x === 'number' || /^\d+$/.test(String(x))) partners.push(partnerName(x));
        };
        const fromAny = (val) => {
          if (!val) return;
          if (Array.isArray(val)) val.forEach(pushName);
          else if (typeof val === 'object') {
            const keys = Object.keys(val);
            // if keys look like roster ids, use keys
            const numericLike = keys.length && keys.every((k) => /^\d+$/.test(k));
            if (numericLike) keys.forEach(pushRosterId);
            else {
              // otherwise try values
              Object.values(val).forEach(pushRosterId);
            }
          } else pushName(val);
        };
        // Prefer explicit roster_ids order for Team A/B if present
        if (Array.isArray(rowObj.roster_ids) && rowObj.roster_ids.length) {
          rowObj.roster_ids.forEach(pushRosterId);
        }
        fromAny(rowObj.partner_team_names);
        fromAny(rowObj.partners);
        fromAny(rowObj.team_names);
        fromAny(rowObj.teams);
        fromAny(rowObj.usernames);
        fromAny(base.partner_team_names);
        fromAny(base.partners);
        fromAny(base.team_names);
        fromAny(base.teams);
        fromAny(base.usernames);
        if (Array.isArray(base.roster_ids) && base.roster_ids.length) {
          base.roster_ids.forEach(pushRosterId);
        }
        // Deduplicate preserving order
        const partnersUnique = [];
        partners.forEach((p) => { if (!partnersUnique.includes(p)) partnersUnique.push(p); });
        // Expose first two partners as Team A/B (favor rowObj.roster_ids ordering if present)
        rowObj.trade_team_a = partnersUnique[0] || rowObj.trade_team_a || '';
        rowObj.trade_team_b = partnersUnique[1] || rowObj.trade_team_b || '';
        rowObj.trade_partners = partnersUnique.join(', ');

        // Type (search common fields)
        const pickType = (obj) => {
          if (!obj || typeof obj !== 'object') return undefined;
          return obj.type || obj.trade_type || obj.transaction_type || obj.action || obj.kind ||
                 (obj.metadata && (obj.metadata.type || obj.metadata.kind));
        };
        rowObj.trade_type = pickType(rowObj) || pickType(base) || rowObj.trade_type || 'trade';

        // Assets per receiving roster
        const receivers = new Map(); // roster_id -> { players:[], picks:[] }
        // players received (primary: Sleeper adds map player_id -> roster_id)
        if (base.adds && typeof base.adds === 'object') {
          Object.entries(base.adds).forEach(([playerId, rosterId]) => {
            const rid = Number(rosterId);
            if (!receivers.has(rid)) receivers.set(rid, { players: [], picks: [] });
            const nm = resolveNameFromAny(playerId);
            if (nm) receivers.get(rid).players.push(nm);
          });
        }
        // fallback: paired arrays (adds_ids with corresponding roster receivers)
        if (Array.isArray(base.adds_ids)) {
          const recv = base.adds_roster_ids || base.adds_receivers || base.receivers || base.to || base.owner_ids;
          if (Array.isArray(recv) && recv.length === base.adds_ids.length) {
            base.adds_ids.forEach((pid, i) => {
              const rid = Number(recv[i]);
              if (!rid) return;
              if (!receivers.has(rid)) receivers.set(rid, { players: [], picks: [] });
              const nm = resolveNameFromAny(pid);
              if (nm) receivers.get(rid).players.push(nm);
            });
          }
        }
        // fallback: scan arrays of objects for player assets with receiver fields
        const addReceivedPlayer = (pid, rid) => {
          const r = Number(rid);
          if (!r || pid === undefined || pid === null) return;
          if (!receivers.has(r)) receivers.set(r, { players: [], picks: [] });
          const nm = resolveNameFromAny(pid);
          if (nm) receivers.get(r).players.push(nm);
        };
        Object.entries(base).forEach(([k, v]) => {
          if (!Array.isArray(v)) return;
          const key = String(k).toLowerCase();
          if (/pick/.test(key)) return; // handled elsewhere
          v.forEach((item) => {
            if (item && typeof item === 'object') {
              // Skip if it looks like a pick object
              if ('season' in item && 'round' in item) return;
              const pid = item.player_id ?? item.id ?? item.player ?? item.pid ?? item.playerId ?? item.playerID ?? item.sleeper_id;
              const rid = item.roster_id ?? item.owner_id ?? item.receiver ?? item.recipient ?? item.to ?? item.to_roster_id;
              if (pid !== undefined && rid !== undefined) addReceivedPlayer(pid, rid);
            }
          });
        });

        // Final fallback logic: handle raw adds/drops arrays without receiver hints
        const teamA = smdTeams.find(t => t.username === rowObj.trade_team_a);
        const teamB = smdTeams.find(t => t.username === rowObj.trade_team_b);
        const ridA = teamA ? Number(teamA.roster_id) : undefined;
        const ridB = teamB ? Number(teamB.roster_id) : undefined;

        const isSymmetric = Array.isArray(base.adds) && Array.isArray(base.drops)
          && base.adds.length === base.drops.length && base.adds.length > 0;
        // Only attribute all adds to Team A if we do NOT have a symmetric adds/drops case
        if (!isSymmetric) {
          if (Array.isArray(base.adds) && ridA) {
            base.adds.forEach((p) => {
              const nm = resolveNameFromAny(p);
              if (!nm) return;
              if (!receivers.has(ridA)) receivers.set(ridA, { players: [], picks: [] });
              receivers.get(ridA).players.push(nm);
            });
          }
          if (Array.isArray(base.adds_ids) && ridA) {
            base.adds_ids.forEach((pid) => {
              const nm = resolveNameFromAny(pid);
              if (!nm) return;
              if (!receivers.has(ridA)) receivers.set(ridA, { players: [], picks: [] });
              receivers.get(ridA).players.push(nm);
            });
          }
        }
        // Do not add 'drops' to receiving assets; drops represent assets leaving a team.
        // fallback: scan for objects that look like roster_id -> [player_ids]
        Object.entries(base).forEach(([k, v]) => {
          const kk = String(k).toLowerCase();
          if (!(/adds|received|players/.test(kk))) return;
          if (v && typeof v === 'object' && !Array.isArray(v)) {
            Object.entries(v).forEach(([ridKey, arr]) => {
              const rid = Number(ridKey);
              if (!rid || !Array.isArray(arr)) return;
              arr.forEach((pid) => {
                if (!receivers.has(rid)) receivers.set(rid, { players: [], picks: [] });
                const nm = resolveNameFromAny(pid && pid.player_id ? pid.player_id : pid);
                if (nm) receivers.get(rid).players.push(nm);
              });
            });
          }
        });
        // picks received
        if (Array.isArray(base.draft_picks)) {
          base.draft_picks.forEach((pick) => {
            if (!pick || typeof pick !== 'object') return;
            // Receiving roster for the pick should prefer new owner identifiers
            const rid = Number(pick.owner_id || pick.receiver || pick.recipient || pick.to || pick.to_roster_id || pick.roster_id);
            if (!rid) return;
            if (!receivers.has(rid)) receivers.set(rid, { players: [], picks: [] });
            receivers.get(rid).picks.push(
              (() => {
                const { season, round, roster_id, owner_id, og_owner_id } = pick;
                if (season && round) {
                  const owner = partnerName(roster_id || owner_id || og_owner_id || '');
                  return `${season} R${round}${owner ? ` (${owner})` : ''}`;
                }
                try { return JSON.stringify(pick); } catch (_) { return String(pick); }
              })()
            );
          });
        }
        // fallback: alternative picks arrays
        const pickArrays = ['picks', 'received_picks', 'picks_received'];
        pickArrays.forEach((name) => {
          const arr = base[name];
          if (Array.isArray(arr)) {
            arr.forEach((pick) => {
              if (!pick || typeof pick !== 'object') return;
              const rid = Number(pick.owner_id || pick.receiver || pick.recipient || pick.to || pick.to_roster_id || pick.roster_id);
              if (!rid) return;
              if (!receivers.has(rid)) receivers.set(rid, { players: [], picks: [] });
              receivers.get(rid).picks.push(
                (() => {
                  const { season, round, roster_id, owner_id, og_owner_id } = pick;
                  if (season && round) {
                    const owner = partnerName(roster_id || owner_id || og_owner_id || '');
                    return `${season} R${round}${owner ? ` (${owner})` : ''}`;
                  }
                  try { return JSON.stringify(pick); } catch (_) { return String(pick); }
                })()
              );
            });
          }
        });

        // Heuristic fallback: when adds/drops are symmetric lists with no receiver info,
        // split players between Team A and Team B (first to A, rest to B)
        const totalPlayersAssigned = Array.from(receivers.values())
          .reduce((sum, v) => sum + (v.players ? v.players.length : 0), 0);
        const ensureBucket = (rid) => {
          if (!receivers.has(rid)) receivers.set(rid, { players: [], picks: [] });
          return receivers.get(rid);
        };
        const teamAUser = rowObj.trade_team_a;
        const teamBUser = rowObj.trade_team_b;
        const teamAObj = smdTeams.find(t => t.username === teamAUser);
        const teamBObj = smdTeams.find(t => t.username === teamBUser);
        const ridA2 = teamAObj ? Number(teamAObj.roster_id) : undefined;
        const ridB2 = teamBObj ? Number(teamBObj.roster_id) : undefined;
        if (totalPlayersAssigned === 0 && isSymmetric && ridA2 && ridB2) {
          const names = base.adds.map((p) => resolveNameFromAny(p)).filter(Boolean);
          if (names.length) {
            ensureBucket(ridA2).players.push(names[0]);
            if (names.length > 1) ensureBucket(ridB2).players.push(...names.slice(1));
          }
        } else if (totalPlayersAssigned === 0 && Array.isArray(base.adds_ids) && Array.isArray(base.drops_ids)
            && base.adds_ids.length === base.drops_ids.length && base.adds_ids.length > 0 && ridA2 && ridB2) {
          const names = base.adds_ids.map((pid) => resolveNameFromAny(pid)).filter(Boolean);
          if (names.length) {
            ensureBucket(ridA2).players.push(names[0]);
            if (names.length > 1) ensureBucket(ridB2).players.push(...names.slice(1));
          }
        }

        // No computation of per-side assets here; rely on source-provided
        // trade_team_a_assets and trade_team_b_assets fields.

        // If team names missing, derive from receiver roster ids
        if (!rowObj.trade_team_a || !rowObj.trade_team_b) {
          const ridKeys = Array.from(receivers.keys());
          // Prefer explicit roster_ids ordering
          const ridList = Array.isArray(rowObj.roster_ids) ? rowObj.roster_ids.map((x) => Number(x)).filter(Boolean) : [];
          if (ridList.length) {
            if (!rowObj.trade_team_a) rowObj.trade_team_a = partnerName(ridList[0]);
            if (!rowObj.trade_team_b && ridList.length > 1) rowObj.trade_team_b = partnerName(ridList[1]);
          } else if (ridKeys.length) {
            if (!rowObj.trade_team_a) rowObj.trade_team_a = partnerName(ridKeys[0]);
            if (!rowObj.trade_team_b && ridKeys.length > 1) rowObj.trade_team_b = partnerName(ridKeys[1]);
          }
        }

        // Retain (but not displayed) waiver/id if needed later
        const wb = base.waiver_budget;
        if (wb && typeof wb === 'object') {
          let sum = 0; Object.values(wb).forEach((v) => { const n = Number(v); if (!isNaN(n)) sum += n; });
          rowObj.trade_waiver = sum;
        } else if (typeof wb === 'number') {
          rowObj.trade_waiver = wb;
        }
        if (base.transaction_id) rowObj.trade_id = base.transaction_id;
      });
    }

    // Allow tables that return objects with nested arrays
    if (!Array.isArray(rows)) {
      const dataObj = (rows && typeof rows === 'object') ? rows : (product.data || {});

      // Collect candidate arrays from various spots
      const candidates = [];

      const pushIfArray = (val) => { if (Array.isArray(val)) candidates.push(val); };

      // Explicit keys based on props
      if (props.table) {
        pushIfArray(dataObj[props.table]);
        if (dataObj[props.table] && typeof dataObj[props.table] === 'object') {
          Object.values(dataObj[props.table]).forEach(pushIfArray);
        }
      }
      if (props.type) {
        pushIfArray(dataObj[props.type]);
        if (dataObj[props.type] && typeof dataObj[props.type] === 'object') {
          Object.values(dataObj[props.type]).forEach(pushIfArray);
        }
      }

      // Common container keys
      ['data', 'items', 'rows', 'list', 'players', 'result'].forEach((k) => pushIfArray(dataObj[k]));

      // Any top-level array value
      Object.values(dataObj).forEach(pushIfArray);

      // One level deeper arrays
      Object.values(dataObj).forEach((val) => {
        if (val && typeof val === 'object') {
          Object.values(val).forEach(pushIfArray);
        }
      });

      // If we found multiple candidates, prefer the one matching our columns
      const columns = Array.isArray(props.headCells) ? props.headCells.map((h) => h.id) : [];
      const scored = candidates
        .filter(Array.isArray)
        .map((arr) => {
          const first = arr.find((x) => x && typeof x === 'object') || {};
          const keys = new Set(Object.keys(first));
          const match = columns.reduce((acc, c) => acc + (keys.has(c) ? 1 : 0), 0);
          return { arr, match };
        })
        .sort((a, b) => b.match - a.match);

      let picked = scored.length ? scored[0].arr : undefined;

      // Convert object map to array as a last resort
      if (!picked && dataObj && typeof dataObj === 'object') {
        const vals = Object.values(dataObj);
        if (vals.length && vals.every((v) => typeof v === 'object')) picked = vals;
      }

      rows = Array.isArray(picked) ? picked : [];
    }
  }


  const handleRequestSort = (event, property) => {
    const isAsc = orderBy === property && order === 'asc';
    setOrder(isAsc ? 'desc' : 'asc');
    setOrderBy(property);
  };

  // const handleSelectAllClick = (event) => {
  //   if (event.target.checked) {
  //     const newSelected = rows.map((n) => n.name);
  //     setSelected(newSelected);
  //     return;
  //   }
  //   setSelected([]);
  // };

  const handleClick = (event, name) => {
    const selectedIndex = selected.indexOf(name);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, name);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(
        selected.slice(0, selectedIndex),
        selected.slice(selectedIndex + 1),
      );
    }

    setSelected(newSelected);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleChangeDense = (event) => {
    setDense(event.target.checked);
  };

  const isSelected = (name) => selected.indexOf(name) !== -1;

  // Avoid a layout jump when reaching the last page with empty rows.
  const emptyRows =
    page > 0 ? Math.max(0, (1 + page) * rowsPerPage - rows.length) : 0;

  
  
  if(rows){
    // Optional row-level filtering (e.g., search)
    if (props && typeof props.rowFilter === 'function' && Array.isArray(rows)) {
      try {
        rows = rows.filter((r) => props.rowFilter(r));
      } catch (e) {
        // no-op on filter errors to avoid breaking table
      }
    }
    if (props && typeof props.rowAugment === 'function' && Array.isArray(rows)) {
      try { rows.forEach((r) => props.rowAugment(r)); } catch (_) {}
    }
    if (Array.isArray(rows) && rows.length === 0 && product.data !== undefined) {
      try {
        // Help diagnose unexpected shapes during development
        // eslint-disable-next-line no-console
        const pd = product.data;
        const keys = (pd && typeof pd === 'object') ? Object.keys(pd) : [];
        console.warn('MuiTable: no rows found. Keys in response:', keys);
      } catch (_) {}
    }
    // console.log(rows)


    return (
      <Box >
        <Paper
          sx={{
            mb: 2,
            backgroundImage: 'none',
            backgroundColor: (theme) =>
                    theme.palette.mode === 'dark' ? '#1A2027' : '#fff',
            }}
          elevation={6}
        >
          <EnhancedTableToolbar className="uppercase" numSelected={selected.length} title={props.title}/>
          <TableContainer
            width="max-content"
          >
            <Table
              // classes={{root: classes.customTable}}
              // sx={{ minWidth: 750 }}
              aria-labelledby="tableTitle"
              size={dense ? 'small' : 'medium'}
            >
              <EnhancedTableHead
                numSelected={selected.length}
                order={order}
                orderBy={orderBy}
                // onSelectAllClick={handleSelectAllClick}
                onRequestSort={handleRequestSort}
                rowCount={rows.length}
                headCells={props.headCells}
              />
              <TableBody>
                {/* if you don't need to support IE11, you can replace the `stableSort` call with:
                  rows.sort(getComparator(order, orderBy)).slice() */}
                {stableSort(rows || [], getComparator(order, orderBy))
                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((row, index) => {
                    const isItemSelected = isSelected(row);
                    const labelId = `enhanced-table-checkbox-${index}`;
                    // let testcols = []
                    // for (let i = 0; i < props.cols.length; i++) {
                    //   testcols.push(props.cols[i]);
                    // }
                    // console.log(testcols)
                    // let cols = [row.username, row.trades, row.trades_2022, row.trades_2021, row.trades_2020]

                    return (
                      <TableRow
                        hover
                        onClick={(event) => handleClick(event, row)}
                        role="checkbox"
                        aria-checked={isItemSelected}
                        tabIndex={-1}
                        key={index}
                        selected={isItemSelected}
                      >
                        {/* <TableCell padding="checkbox"> */}
                          {/* <Checkbox
                            color="primary"
                            checked={isItemSelected}
                            inputProps={{
                              'aria-labelledby': labelId,
                            }}
                          /> */}
                        {/* </TableCell> */}
                        {/* <TableCell
                          component="th"
                          id={labelId}
                          scope="row"
                          padding="none"
                        >
                          {row.username}
                        </TableCell> */}

                        {props.headCells.map((header) => {
                          const val = row[header.id];
                          let display = val;
                          if (val === null || val === undefined) {
                            display = '';
                          } else if (Array.isArray(val)) {
                            display = val.join('\n');
                          } else if (typeof val === 'object') {
                            // Prefer readable date if it's a Date
                            if (val instanceof Date) {
                              display = val.toLocaleDateString('en-US');
                            } else {
                              // Fallback to JSON for objects to avoid React errors
                              try { display = JSON.stringify(val); } catch (_) { display = String(val); }
                            }
                          }
                          const extraSx = typeof props.cellSx === 'function' ? (props.cellSx(row, header) || {}) : {};
                          return (
                            <TableCell
                              key={header.id}
                              sx={{
                                fontSize: "small",
                                padding: "6px 0px 6px 6px",
                                whiteSpace: 'pre-line',
                                ...(header.minWidth ? { minWidth: header.minWidth } : {}),
                                ...(header.maxWidth ? { maxWidth: header.maxWidth } : {}),
                                ...(header.width ? { width: header.width } : {}),
                                ...(header.sx || {}),
                                ...extraSx,
                              }}
                              className="text-sm"
                              size="small"
                              align="left"
                            >
                              {display}
                            </TableCell>
                          );
                        })}
                        {/* {cols.map((cell, i) => {
                          return (
                            <TableCell align="left">{cell}</TableCell>
                          );
                        })
                        } */}

                        {/* <TableCell align="left">{row.trades}</TableCell>
                        <TableCell align="left">{row.trades_2022}</TableCell>
                        <TableCell align="left">{row.trades_2021}</TableCell>
                        <TableCell align="left">{row.trades_2020}</TableCell> */}
                      </TableRow>
                    );
                  })}
                {emptyRows > 0 && (
                  <TableRow
                    style={{
                      height: (dense ? 33 : 53) * emptyRows,
                    }}
                  >
                    <TableCell colSpan={6} />
                  </TableRow>
                )}
              </TableBody>
            </Table>
          </TableContainer>
          {props.debugJson && (
            <Box sx={{ p: 2 }}>
              <Typography variant="subtitle2">Raw rows (post-processed)</Typography>
              <Paper variant="outlined" sx={{ p: 1, maxHeight: 300, overflow: 'auto' }}>
                <pre style={{ margin: 0, fontSize: '0.75rem' }}>
{JSON.stringify(rows, null, 2)}
                </pre>
              </Paper>
            </Box>
          )}
          <TablePagination
            rowsPerPageOptions={[5, 10, 15, 25, 30, 50]}
            component="div"
            count={(rows || []).length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </Paper>
        {/* <FormControlLabel
          control={<Switch checked={dense} onChange={handleChangeDense} />}
          label="Dense padding"
        /> */}
      </Box>
    );
  }
}
